import { render, staticRenderFns } from "./temcenter2.vue?vue&type=template&id=bb643330&scoped=true"
import script from "./temcenter2.vue?vue&type=script&lang=js"
export * from "./temcenter2.vue?vue&type=script&lang=js"
import style0 from "./temcenter2.vue?vue&type=style&index=0&id=bb643330&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb643330",
  null
  
)

export default component.exports